export const buttonWithImage = ({
  size = "medium", // medium | large
  UIVersion,
  isSelectedOrOverride,
}) => ({
  paddingRight: "5px",
  justifyContent: "space-between",
  maxWidth: size === "medium" && "260px",
  flexGrow: size === "large" ? 0 : 1,
  flexShrink: size === "large" ? 0 : 1,
  userSelect: "none",

  ".button__icon-after": {
    marginLeft: size === "medium" && UIVersion === 1 && "0",
    marginRight: "0",
    borderRadius: "10000px",
    border: "solid 1px",
    borderColor: isSelectedOrOverride ? "#FFFFFF" : "grey5",
    overflow: "hidden",
    height: size === "large" ? "50px" : "30px",
    width: size === "large" ? "50px" : "30px",
    flexGrow: 0,
    flexShrink: 0,

    "img,svg": {
      minWidth: "100%",
      minHeight: "100%",
    },
  },
});

export const desktopLayout = {
  mx: "-40px",
};

export const mobileLayout = {
  px: "40px",
};

export const item = ({ UIVersion }) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",

  maxWidth: "280px",
  width: UIVersion === 2 ? "auto" : "100%",
});

export const infoIconContainer = {
  marginLeft: "20px",
  width: "24px",
  flexGrow: 0,
  flexShrink: 0,

  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
};

export const infoIconButton = {
  cursor: "pointer",
  height: "24px",
  width: "24px",
};

// ! Needs tweaking, something seems to override some changes
export const iconCSSContainer = ({ isSelected, background }) => ({
  background: background ? background : "white",
  border: "solid",
  borderWidth: isSelected ? "2px" : "1px",
  borderColor: isSelected ? "white" : "grey5",
  borderRadius: "10000px",
  boxShadow: isSelected ? "0px 5px 10px rgba(0, 0, 0, 0.125)" : "none",
  cursor: "pointer",
  padding: "0",
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
  justifyContent: "center",
  overflow: "hidden",
  width: "60px",
  height: "60px",
  flexGrow: 0,
  flexShrink: 0,

  "img, svg": {
    display: "block",
  },

  "&:hover, &:focus": {
    borderColor: "primary",
  },

  position: "relative",
  "&:after": background && {
    content: '""',
    position: "absolute",
    width: "100%",
    height: "100%",
    borderRadius: "1000px",
    background:
      "linear-gradient(135deg, #000000 0%, #FFFFFF 50%, #000000 100%)",
    mixBlendMode: "multiply",
    opacity: "0.25",
    top: 0,
    left: 0,
  },
});
